export const Divider: React.FC = () => {
    return (
        <hr style={{
            backgroundColor: 'var(--ion-color-step-100)'
        }} />
    );
};
